module.exports = __webpack_public_path__ + "static/logo-9e92430da814299e249cb4359f6beaf7.png";